<template xmlns="http://www.w3.org/1999/html">
  <el-container id="ActivityEvaluate">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{ color: l.colour, lineHeight: 0.4 }">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main2">
      <el-main :style=divStyle>
        <div style="display:flex;height:11vh;width:100%;margin:0">
          <div style="display:flex;width:33.3%;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:100px;margin:1vh">
              <p style="margin: 0;color: #000000;font-weight:bold;font-size:15px">评价总数</p>
              <p style="font-weight:bold;margin-top:10px;margin-left:3px;font-size:25px">{{ d_statis.total }}</p>
            </div>
          </div>
          <div
            style="display:flex;width:33.3%;margin-left:5px;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:100px;margin:1vh">
              <p style="margin: 0;color: #000000;font-weight:bold;font-size:15px">平均评分</p>
              <p style="font-weight:bold;margin-top:10px;margin-left:3px;font-size:25px">{{ d_statis.aveNum }}</p>
            </div>
          </div>
          <div
            style="display:flex;width:33.3%;margin-left:5px;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:100px;margin:1vh">
              <p style="margin: 0;color: #000000;font-weight:bold;font-size:15px">有意见评价</p>
              <p style="font-weight:bold;margin-top:10px;margin-left:3px;font-size:25px">{{ d_statis.hasMoreNum }}</p>
            </div>
          </div>
        </div>
        <div
          style="height:auto;margin-top:5px;padding-left:10px;padding-right:10px;padding-bottom:20px;background-color:#FFFFFF">
          <p style="font-size:20px;padding-top:10px;margin-bottom:10px;margin-top:0px;font-weight:bold">评分分布</p>
          <div style="display:flex;width:100%;">
            <div
              style="display:flex;width:20%;background-color:#F4F4F4;margin-right:10px;border-radius: 5px 5px 5px 5px;">
              <div style="display:flex;flex-direction:column;width:100%;padding:10px;text-align:center">
                <el-rate v-model="pf_img5" disabled :max="5" text-color="#ff9900" score-template="{value}">
                </el-rate>
                <p style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;font-size:17px">
                  五星评价
                </p>
                <p
                  style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;margin-left:3px;font-size:20px">
                  {{ d_statis.start5 }}
                </p>
                <p style="margin-top:10px;margin-bottom:10px;color:#6B7280;font-size:15px">
                  {{ (parseFloat(d_statis.start5Ratio) * 100).toFixed(2) }}%
                </p>
              </div>
            </div>
            <div
              style="display:flex;width:20%;background-color:#F4F4F4;margin-right:10px;border-radius: 5px 5px 5px 5px;">
              <div style="display:flex;flex-direction:column;width:100%;padding:10px;text-align:center">
                <el-rate v-model="pf_img4" disabled :max="4" text-color="#ff9900" score-template="{value}">
                </el-rate>
                <p style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;font-size:17px">
                  四星评价
                </p>
                <p
                  style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;margin-left:3px;font-size:20px">
                  {{ d_statis.start4 }}
                </p>
                <p style="margin-top:10px;margin-bottom:10px;color:#6B7280;font-size:15px">
                  {{ (parseFloat(d_statis.start4Ratio) * 100).toFixed(2) }}%
                </p>
              </div>
            </div>
            <div
              style="display:flex;width:20%;background-color:#F4F4F4;margin-right:10px;border-radius: 5px 5px 5px 5px;">
              <div style="display:flex;flex-direction:column;width:100%;padding:10px;text-align:center">
                <el-rate v-model="pf_img3" disabled :max="3" text-color="#ff9900" score-template="{value}">
                </el-rate>
                <p style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;font-size:17px">
                  三星评价
                </p>
                <p
                  style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;margin-left:3px;font-size:20px">
                  {{ d_statis.start3 }}
                </p>
                <p style="margin-top:10px;margin-bottom:10px;color:#6B7280;font-size:15px">
                  {{ (parseFloat(d_statis.start3Ratio) * 100).toFixed(2) }}%
                </p>
              </div>
            </div>
            <div
              style="display:flex;width:20%;background-color:#F4F4F4;margin-right:10px;border-radius: 5px 5px 5px 5px;">
              <div style="display:flex;flex-direction:column;width:100%;padding:10px;text-align:center">
                <el-rate v-model="pf_img2" disabled :max="2" text-color="#ff9900" score-template="{value}">
                </el-rate>
                <p style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;font-size:17px">
                  二星评价
                </p>
                <p
                  style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;margin-left:3px;font-size:20px">
                  {{ d_statis.start2 }}
                </p>
                <p style="margin-top:10px;margin-bottom:10px;color:#6B7280;font-size:15px">
                  {{ (parseFloat(d_statis.start2Ratio) * 100).toFixed(2) }}%
                </p>
              </div>
            </div>
            <div
              style="display:flex;width:20%;background-color:#F4F4F4;margin-right:0px;border-radius: 5px 5px 5px 5px;">
              <div style="display:flex;flex-direction:column;width:100%;padding:10px;text-align:center">
                <el-rate v-model="pf_img1" disabled :max="1" text-color="#ff9900" score-template="{value}">
                </el-rate>
                <p style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;font-size:17px">
                  一星评价
                </p>
                <p
                  style="margin-top:10px;margin-bottom:0px;font-weight:bold;color: #000000;margin-left:3px;font-size:20px">
                  {{ d_statis.start1 }}
                </p>
                <p style="margin-top:10px;margin-bottom:10px;color:#6B7280;font-size:15px">
                  {{ (parseFloat(d_statis.start1Ratio) * 100).toFixed(2) }}%
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:5px;padding-left:10px;padding-right:10px;padding-top:10px;background-color: #FFFFFF">
          <div style="height:40px;background-color:#FFFFFF;">
            <el-input placeholder="请输入活动名称" style="width:10vw;margin-left:5px" prefix-icon="el-icon-search"
                      clearable
                      @change="getDataList()" v-model="edi_ActivityName">
            </el-input>
            <el-input placeholder="请输入用户名称" style="width:10vw;margin-left:5px" prefix-icon="el-icon-search"
                      clearable
                      @change="getDataList()" v-model="edi_name">
            </el-input>
            <el-input placeholder="请输入手机号" style="width:10vw;margin-left:5px" prefix-icon="el-icon-search"
                      clearable
                      @change="getDataList()" v-model="edi_phone">
            </el-input>
            <el-select v-model="edi_state" ref='devSonSelect' @change="getDataList" clearable filterable
                       placeholder="全部评分" style="width:8vw;">
              <el-option v-for="item in li_state" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-button style="margin-left:10px;height:40px;" type="primary" @click="onResh" icon="el-icon-refresh">
              重置
            </el-button>
          </div>
          <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                    style="width:100%; font-size:13px; background:#FFFFFF;margin-top: 10px;" show-overflow-tooltip
                    :header-cell-style="{ 'height': '30px', 'text-align': 'center', 'background': '#f4f4f4', 'color': '#0dA7C8' }">
            <el-table-column width="01" sortable/>
            <div v-for="(d, item) in this.defHead">
              <el-table-column v-if="!d.key.includes('评分')" :key=item :prop=d.val :label=d.key :width="d.w">
              </el-table-column>
              <el-table-column v-else :key="'score-' + item" :label=d.key :width="d.w">
                <template v-slot="scope">
                  <div style="display:flex;justify-content: center;">
                    <p v-if="scope.row[d.val] >= 5"
                       style="background:#5daf34;font-size:15px;color:#FFFFFF;margin:0;padding:5px;width:50px;border-radius: 15px 15px 15px 15px;">
                      {{ scope.row[d.val] }}星
                    </p>
                    <p v-else-if="scope.row[d.val] >= 4"
                       style="background:#00ff00;font-size:15px;color:#FFFFFF;margin:0;padding:5px;width:50px;border-radius: 15px 15px 15px 15px;">
                      {{ scope.row[d.val] }}星
                    </p>
                    <p v-else-if="scope.row[d.val] >= 3"
                       style="background:#ffA93C;font-size:15px;color:#FFFFFF;margin:0;padding:5px;width:50px;border-radius: 15px 15px 15px 15px;">
                      {{ scope.row[d.val] }}星
                    </p>
                    <p v-else-if="scope.row[d.val] >= 2"
                       style="background:#E6A23C;font-size:15px;color:#FFFFFF;margin:0;padding:5px;width:50px;border-radius: 15px 15px 15px 15px;">
                      {{ scope.row[d.val] }}星
                    </p>
                    <p v-else
                       style="background:#fff000;font-size:15px;color:#FFFFFF;margin:0;padding:5px;width:50px;border-radius: 15px 15px 15px 15px;">
                      {{ scope.row[d.val] }}星
                    </p>
                  </div>
                </template>
              </el-table-column>
            </div>
          </el-table>
        </div>
        <el-pagination style="float:right; margin-right:0.5vw;margin-top:5px;margin-bottom:10px;color: #000000;"
                       @size-change="handleSizeChange" @current-change="handleCurrentChange1" :current-page="page"
                       :page-sizes="[10, 20, 30]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name:"ActivityEvaluate",
  data(){
    return {
      h_text:"用户评价管理",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      divStyle:{
        backgroundColor:'#F4F4F4',
        overflow:'auto',
        maxHeight:window.innerHeight - 50
      },
      edi_name:"",
      edi_phone:"",
      edi_ActivityName:"",
      page:1,
      pageSize:10,
      total:0,
      defHead:[
        {'key':"评价时间",'val':"evaTime","w":"200px"},
        {'key':"活动ID",'val':"activityId","w":"auto"},
        {'key':"活动名称",'val':"activityName","w":"auto"},
        {'key':"用户名称",'val':"userName","w":"auto"},
        {'key':"手机号",'val':"phoneNumber","w":"auto"},
        {'key':"内容评分",'val':"content","w":"auto"},
        {'key':"服务评分",'val':"service","w":"auto"},
        {'key':"环境评分",'val':"environment","w":"auto"},
        {'key':"设施评分",'val':"facilities","w":"auto"},
        {'key':"用户意见",'val':"more","w":"auto"}
      ],
      tabData:[],
      pf_img5:5,
      pf_img4:4,
      pf_img3:3,
      pf_img2:2,
      pf_img1:1,
      d_statis:{
        "start1":0,
        "start1Ratio":"0",
        "start2":0,
        "start2Ratio":"0",
        "start3":0,
        "start3Ratio":"0",
        "start4":0,
        "start4Ratio":"0",
        "start5":0,
        "start5Ratio":"0",
        "total":0,
        "aveNum":"0",
        "hasMoreNum":0
      },
      edi_state:"",
      li_state:[
        {label:"5星",value:5},
        {label:"4星",value:4},
        {label:"3星",value:3},
        {label:"2星",value:2},
        {label:"1星",value:1}
      ]
    };
  },
  methods:{ /*方法存放*/
    tableYs({row,column,rowIndex,columnIndex}){ /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange1(val){
      this.page = val;
      this.getDataList();
    },
    onResh(){
      this.edi_name = "";
      this.edi_phone = "";
      this.edi_state = "";
      this.edi_ActivityName = "";
      this.getDataList();
    },
    getDataStatis(){
      const params = {
        "page":1,
        "pageSize":30,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getActivityEvaluateStatis,params,headers).then(res => {
        console.log("getActivityEvaluateStatis:",res.data.data);
        //if (res.data.data) {
        //  d["start1"] = res.data.data["start1"];
        //  d["start1Ratio"] = res.data.data["start1Ratio"];
        //  d["start2"] = res.data.data["start2"];
        //  d["start2Ratio"] = res.data.data["start2Ratio"];
        //  d["start3"] = res.data.data["start3"];
        //  d["start3Ratio"] = res.data.data["start3Ratio"];
        //  d["start4"] = res.data.data["start4"];
        //  d["start4Ratio"] = res.data.data["start4Ratio"];
        //  d["start5"] = res.data.data["start5"];
        //  d["start5Ratio"] = res.data.data["start5Ratio"];
        //  d["total"] = res.data.data["total"];
        //  d["aveNum"] = res.data.data["aveNum"];
        //  d["hasMoreNum"] = res.data.data["hasMoreNum"];
        //}
        this.d_statis = res.data.data;
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取评价总结数据失败");
        }
      });
    },
    initDataList(li_data){ /*初始化列表数据*/
      console.log("Evaluate",li_data);
      let data = li_data['list'];
      let l_d = [];
      for(let i = 0; i < data.length; i++) {
        let d = {
          "id":data["id"],
          "activityId":data["activityId"],
          "activityName":data["activityName"],
          "content":data["content"],
          "contentTitle":data["contentTitle"],
          "description":data["description"],
          "environment":data["environment"],
          "environmentTitle":data["environmentTitle"],
          "evaTime":data["evaTime"],
          "facilities":data["facilities"],
          "facilitiesTitle":data["facilitiesTitle"],
          "more":data["more"],
          "moreTitle":data["moreTitle"],
          "other":data["other"],
          "otherStr":data["otherStr"],
          "otherTitle":data["otherTitle"],
          "phoneNumber":data["phoneNumber"],
          "project":data["project"],
          "projectId":data["projectId"],
          "service":data["service"],
          "servicetitle":data["servicetitle"],
          "userName":data["userName"],
          "userNo":data["userNo"]
        };
        l_d.push(d);
      }
      this.total = li_data.total;
      this.tabData = data;
    },
    getDataList(){ /*获取所有预约信息*/
      const params = {
        "page":this.page,
        "pageSize":this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if(this.edi_name) {
        params['userName'] = this.edi_name;
      }
      if(this.edi_phone) {
        params['phoneNumber'] = this.edi_phone;
      }
      if(this.edi_state) {
        params['rating'] = this.edi_state;
      }
      if(this.edi_ActivityName) {
        params['activityName'] = this.edi_ActivityName;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getActivityEvaluateList,params,headers).then(res => {
        console.log("getDataList:",res.data.data);
        if("list" in res.data.data && res.data.data.list) {
          this.initDataList(res.data.data);
        } else {
          this.total = 0;
          this.tabData = [];
        }
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取活动评价数据失败");
        }
      });
    }
  },
  mounted(){ /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.getDataStatis();
    this.getDataList();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData(){
      return this.tabData.filter(item => {
        this.state = true;
        return this.state;
      });
    }
  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
#ActivityEvaluate {
  height: 100vh;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main2 {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 60px;
  overflow-y: auto;
  border-radius: 5px 5px 5px 5px;
}

.el-rate__icon {
  font-size: 25px;
  /* 调整为你想要的尺寸 */
}

.tab_adb {
  user-select: text;

  .gutter {
    /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    background: #FFFFFF;
    height: calc(100% - 66px) !important;
    /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/ActivityEvaluate.vue